import { LngLatBounds } from "react-map-gl/maplibre";

import { Extent } from "@nens/shared-utils";

export function convertLngLatBoundsToExtent(bounds: LngLatBounds): Extent {
  const west = bounds.getWest();
  const south = bounds.getSouth();
  const east = bounds.getEast();
  const north = bounds.getNorth();

  return [west, south, east, north];
}
